import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TbEdit } from "react-icons/tb";
import { NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/Header";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useStaffPosts } from "../../../hooks/useFetchStateHooks/useStaffPosts";
import { useAppStore } from "../../../stores/RootStore";
import { PositionsTableData } from "../../../types/formDataTypes";
import { Button } from "../../../ui/Button";
import { MenuDataTable } from "../../../ui/DataTable/MenuDataTable";
import { Input } from "../../../ui/Input/Input";
import { Separator } from "../../../ui/Separator";

export const Positions = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = React.useState("");
  const currentSite = useAppStore().currentSite
  const posts = useAppStore((state) => state.posts);


  // Получение данных и обновление их в сторе.
  const updateItems = useStaffPosts();
  useEffect(() => {
    updateItems();
  }, []);  

  let nodes = posts?.map((post) => {
    return {
      id: post.id,
      post_name: post.attributes.name,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => item.post_name.toLowerCase().includes(search.toLowerCase())),
  };

  
  const columns: ColumnDef<PositionsTableData>[] = [
    {
      header: t("title_name"),
      size: 1000,
      cell: ({ row }) => row.original.post_name,
    }
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
          </NavLink>
          <span>/</span>
          <NavLink to={"/data/directories"}>
            <span className="font-medium">{t("directories")}</span>
          </NavLink> 
          <span>/</span>
          {location.pathname == "/data/positions/" || location.pathname == "/data/positions" ? <span>{t("positions")}</span> : <NavLink to={"/data/positions"}><span>{t("positions")}</span></NavLink>}
          {(id || location.pathname == "/data/positions/new") && <span>/</span>}
          {id && <span>{data.nodes.find(n => n.id == id)?.post_name}</span>}
          {location.pathname == "/data/positions/new" && <span>{t('adding_position')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/positions/new" ? <Outlet /> :
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header name={t('positions')} backName={t("directories")} backLink={"/data/directories"} />
          <div className="flex-none flex flex-row w-full h-10 items-center gap-4 justify-between px-6">
            <Input 
              className="h-8"
              placeholder={t("search")}
              onChange={handleSearch}
              value={search}
              autoComplete="off"
              width="100%" 
            />
            <RoleRequire role="maintainer">
              <Button variant={"default"} size={"md"} onClick={() => navigate("new")}>{t("create_position")}</Button>
            </RoleRequire>
          </div>
          <MenuDataTable route="/data/positions" data={data.nodes} columns={columns} onClickRow={navigate} />
        </div>
      }
    </div>
  );
};
